import React from 'react';
import './Loading.css';

/**
 * Componente Reutilizável de Loading para rotinas padrão do sistema.
 * 
 * @param {Object} props
 * @param {string} [props.text='Carregando dados...'] - Mensagem principal exibida
 * @param {string} [props.subtext] - Descrição ou instrução auxiliar
 * @param {'default'|'table'|'overlay'|'card'|'inline'} [props.type='default'] - Modo de renderização
 * @param {'sm'|'md'|'lg'} [props.size='md'] - Dimensão do indicador
 * @param {number} [props.colSpan=12] - Número de colunas para modo 'table'
 * @param {string|number} [props.minHeight] - Altura mínima customizada
 * @param {boolean} [props.showProgress=true] - Exibir barra de progresso shimmer
 * @param {string} [props.className=''] - Classes adicionais
 * @param {Object} [props.style={}] - Estilos inline customizados
 */
const Loading = ({
  text = 'Carregando dados...',
  subtext,
  type = 'default',
  size = 'md',
  colSpan = 12,
  minHeight,
  showProgress = true,
  className = '',
  style = {}
}) => {
  const containerStyle = {
    ...(minHeight ? { minHeight } : {}),
    ...style
  };

  const isInline = type === 'inline';
  const showShimmer = showProgress && !isInline && size !== 'sm';

  const content = (
    <div
      className={`loading-container loading-size-${size} loading-variant-${type} ${className}`}
      style={containerStyle}
      role="status"
      aria-live="polite"
    >
      <div className="loading-spinner-wrapper">
        <div className="loading-spinner-ring" />
        {!isInline && <div className="loading-spinner-core" />}
      </div>

      {text && <h6 className="loading-title">{text}</h6>}

      {subtext && <p className="loading-subtext">{subtext}</p>}

      {showShimmer && (
        <div className="loading-progress-bar">
          <div className="loading-progress-shimmer" />
        </div>
      )}
    </div>
  );

  // Modo Tabela: Retorna tr/td para encaixe perfeito no tbody sem quebrar a semântica da tabela
  if (type === 'table') {
    return (
      <tr className="loading-table-row">
        <td colSpan={colSpan} className="loading-table-cell">
          {content}
        </td>
      </tr>
    );
  }

  return content;
};

// Sub-componentes auxiliares de conveniência
Loading.Table = (props) => <Loading type="table" {...props} />;
Loading.Card = (props) => <Loading type="card" {...props} />;
Loading.Overlay = (props) => <Loading type="overlay" {...props} />;
Loading.Inline = (props) => <Loading type="inline" size="sm" showProgress={false} {...props} />;

export default Loading;
